import * as Sentry from '@sentry/vue'

/**
 * Emitted when `watchLowMemory` toggles device low-memory mode (Tauri / Android).
 * Breadcrumb always; searchable warning event only when entering low memory (noise control).
 *
 * Filter Issues/Discover: `player_low_memory_event:true` or breadcrumbs category `player_low_memory`.
 */
export function addPlayerLowMemorySentryBreadcrumb(isLow: boolean): void {
  try {
    Sentry.addBreadcrumb({
      category: 'player_low_memory',
      message: isLow ? 'low_memory_on' : 'low_memory_off',
      level: isLow ? 'warning' : 'info',
      data: { isLow }
    })
    Sentry.setTag('player_low_memory', isLow ? 'true' : 'false')
    if (isLow) {
      Sentry.captureMessage('Player entered low memory mode', {
        level: 'warning',
        tags: {
          player_low_memory_event: 'true',
          player_low_memory: 'true'
        },
        fingerprint: ['player-low-memory-on'],
        extra: { isLow: true }
      })
    }
  }
  catch {
    /* Sentry not initialized or unavailable */
  }
}
